"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _alertsReducer = _interopRequireDefault(require("./alertsReducer"));

var _pipelineReducer = _interopRequireDefault(require("./pipelineReducer"));

var _quotaReducer = _interopRequireDefault(require("./quotaReducer"));

var _usersToScopesReducer = _interopRequireDefault(require("./usersToScopesReducer"));

var _default = (0, _redux.combineReducers)({
  alerts: _alertsReducer.default,
  pipelines: _pipelineReducer.default,
  quotas: _quotaReducer.default,
  usersToScopes: _usersToScopesReducer.default
});

exports.default = _default;
module.exports = exports.default;